<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
      </div>
      <div style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe"
             style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;">
            <div class="table">
              <el-row class="cell cell50 borderR" style="font-weight: bold;">常熟高新园中等专业学校学生信息表</el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">系部</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.department }}</el-col>
                <el-col :span="4" class="cell cell50">班级</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.class }}</el-col>
              </el-row>
              <el-row class="cell cell50 borderR" style="font-weight: bold;">学生本人信息</el-row>
              <el-row class="borderR">
                <el-col :span="3" class="cell cell50">学生姓名</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.stuName }}</el-col>
                <el-col :span="3" class="cell cell50">性别</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.gender }}</el-col>
                <el-col :span="3" class="cell cell50">出生年月</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.birth }}</el-col>
                <el-col :span="3" class="cell cell50">籍贯</el-col>
                <el-col :span="3" class="cell cell50 flexCenter" style="line-height: unset;word-break: break-all;white-space: break-spaces">{{ detailInfo.location }}</el-col>
              </el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">身份证号码</el-col>
                <el-col :span="20" class="cell cell50">{{ detailInfo.idNumber }}</el-col>
              </el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">家庭住址</el-col>
                <el-col :span="20" class="cell cell50">{{ detailInfo.address }}</el-col>
              </el-row>
              <el-row class="cell cell50 borderR" style="font-weight: bold;">家长信息</el-row>

              <el-row class="flexStretch borderR">
                <el-col :span="3" class="cell cell50">家长姓名</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.parentName1 }}</el-col>
                <el-col :span="3" class="cell cell50">工作单位</el-col>
                <el-col :span="8" class="cell cell50 flexCenter"
                        style="line-height: unset;word-break: break-all;white-space: break-spaces">{{ detailInfo.workplace1 }}</el-col>
                <el-col :span="3" class="cell cell50">联系电话</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.phone1 }}</el-col>
              </el-row>
              <el-row class="flexStretch borderR borderB">
                <el-col :span="3" class="cell cell50">家长姓名</el-col>
                <el-col :span="3" class="cell cell50">{{ detailInfo.parentName2 }}</el-col>
                <el-col :span="3" class="cell cell50">工作单位</el-col>
                <el-col :span="8" class="cell cell50 flexCenter"
                        style="line-height: unset;word-break: break-all;white-space: break-spaces">{{ detailInfo.workplace2 }}</el-col>
                <el-col :span="3" class="cell cell50">联系电话</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.phone2 }}</el-col>
              </el-row>
            </div>

          </div>

        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {


  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
    }
  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.flexStretch{
  display: flex;justify-content: flex-start;align-items: stretch;
}
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
  .borderR {border-right: 1px solid #333;}
  .borderB {border-bottom: 1px solid #333;}
  .FS18{
    font-size: 18px;
  }
  .bold{
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
  .cell{
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family:"宋体";
  }
  .cell50{
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family:"宋体";
  }
  .cellMore{
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family:"宋体";
  }
}
.uline {
  text-decoration: underline;
}
</style>
